import { render, staticRenderFns } from "./righttopIcon.vue?vue&type=template&id=3c71e809&scoped=true&"
import script from "./righttopIcon.vue?vue&type=script&lang=js&"
export * from "./righttopIcon.vue?vue&type=script&lang=js&"
import style0 from "./righttopIcon.vue?vue&type=style&index=0&id=3c71e809&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c71e809",
  null
  
)

export default component.exports